import { get, post } from '../axios'
import { z } from 'zod'
import { account } from './account'
import { leadgenForm } from './leadgen-form'
import { setupCheckResult } from './setup-check'

export const redirectFacebook = () => {
    return post(z.string(), '/facebook/redirect', {})
}

export const disconnectFacebook = () => {
    return post(z.string(), '/facebook/disconnect', {})
}

export const facebookAccounts = () => {
    return get(account.array(), '/facebook/accounts')
}

export const facebookLeadgenForms = (accountId: string) => {
    return get(leadgenForm.array(), `/facebook/${accountId}/leadgen-forms`)
}

export const checkFacebookSetup = () => {
    return get(setupCheckResult, '/facebook/check-setup')
}

export const checkFacebookLeadSetup = (data: { accountId?: string; formId?: string }) => {
    return post(setupCheckResult, '/facebook/check-lead-setup', data)
}

export const campaignFacebookAccounts = (campaignId: string) => {
    return get(account.array(), `/campaigns/${campaignId}/facebook/accounts`)
}

export const campaignFacebookLeadgenForms = (campaignId: string, accountId: string) => {
    return get(leadgenForm.array(), `/campaigns/${campaignId}/facebook/${accountId}/leadgen-forms`)
}

export const checkCampaignFacebookLeadSetup = (campaignId: string, data: { accountId?: string; formId?: string }) => {
    return post(setupCheckResult, `/campaigns/${campaignId}/facebook/check-lead-setup`, data)
}
